module.exports = __webpack_public_path__ + "static/media/argila-verde.d4555039.png";